import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const VideoFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default VideoFilter;
